import { useSelector } from "react-redux";

// read-only primitive selector so consumers re-render only when the
// preference itself flips, not on every advisor object replacement
function useShowNewClientCard() {
  return useSelector(({ hubly }) => {
    return Boolean(hubly?.data?.advisor?.preferences?.showNewClientCard);
  });
}

export default useShowNewClientCard;
